var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.data),function(array,prefix){return [_vm._l((array),function(item){return [_c('div',{key:(prefix + "-" + (item.id)),domProps:{"innerHTML":_vm._s(_vm.display(prefix, item))}})]})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }